import React from "react";

const OrgIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <path d="M2 19V8L9 5V19H2ZM10 19V5L14 3V19H10ZM15 19V8L22 5V19H15Z" fill="#6D7885" />
    </svg>
  );
};

export default OrgIcon;
